import { EDecision } from '@if/core/types';
import { useEffect, useRef, useState } from 'react';
const getPhase = (creditApp) => {
    if (creditApp?.prequalificationDecision?.decision === EDecision.Approved &&
        creditApp.consentHardHit === true &&
        creditApp.normsDecision === null) {
        return 'hardHit';
    }
    return 'prequal';
};
const getMessageKey = (progress, phase) => {
    if (phase === 'hardHit')
        return 'loader.creditCheck';
    if (progress < 30)
        return 'loader.submitting';
    if (progress < 60)
        return 'loader.evaluating';
    return 'loader.almostDone';
};
export const useSubmissionProgress = (creditApp) => {
    const [progress, setProgress] = useState(0);
    const phaseRef = useRef('prequal');
    const phase = getPhase(creditApp);
    useEffect(() => {
        if (phase === 'hardHit' && phaseRef.current === 'prequal') {
            phaseRef.current = 'hardHit';
            setProgress((prev) => Math.max(prev, 50));
        }
    }, [phase]);
    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 90)
                    return 90;
                // Slow down as we approach 90
                const remaining = 90 - prev;
                const increment = Math.max(0.5, remaining / 90);
                return Math.min(90, prev + increment);
            });
        }, 1000);
        return () => clearInterval(interval);
    }, []);
    return {
        progress,
        messageKey: getMessageKey(progress, phase),
    };
};
